import React, { useState } from 'react';

import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './AskForHelpSheet.scss';

/** One line on what's unclear; the link goes to the team lead's escalated list. */
const AskForHelpSheet = () => {
  const { isKeysOpen, answer, closeSheet } = useLinksToCheckContext();
  const [note, setNote] = useState('');

  const sendNote = e => {
    e.preventDefault();
    if (note.trim()) answer({ kind: 'help', note: note.trim() });
  };

  useWindowKeydown(e => {
    if (e.key !== 'Escape' || isKeysOpen) return;
    e.preventDefault();
    closeSheet();
  });

  return (
    <form className='ask-for-help-sheet' aria-label='Ask for help' onSubmit={sendNote}>
      <h3>What’s unclear?</h3>
      <input autoFocus value={note} placeholder='e.g. Two colours on the page, which one is it?' onChange={e => setNote(e.target.value)} />
      <div className='sheet-muted'>Sends this link to the team lead with your note.</div>
      <div className='sheet-footer'>
        <button type='button' className='ltc-btn ghost' onClick={closeSheet}>
          Cancel <span className='ltc-key'>Esc</span>
        </button>
        <button type='submit' className='ltc-btn primary' disabled={!note.trim()}>
          Send <span className='ltc-key'>↵</span>
        </button>
      </div>
    </form>
  );
};

export default AskForHelpSheet;
